import {
  Box,
  Paper,
  Grid,
  TextField,
  styled,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText
} from '@mui/material';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useEffect, useState } from 'react';
import { api } from '../../../api';
import { SystemConfig } from '../../../schema/system_config';

const SystemSchedule = () => {
  const [schedule_start_time, set_schedule_start_time] = useState<Date | null>(null);

  const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const openSuccessDialog = () => {
    setIsOpenSuccessDialog(true);
    setTimeout(() => {
      setIsOpenSuccessDialog(false);
    }, 1000);
  };
  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    if (schedule_start_time) {
      setIsLoading(true);
      api
        .post(`/system_config/schedule`, {
          schedule_start_time: schedule_start_time
            ? `${schedule_start_time.getHours()}:${schedule_start_time.getMinutes()}`
            : null
        })
        .then(() => {
          openSuccessDialog();
        })
        .finally(() => setIsLoading(false));
    }
  };

  useEffect(() => {
    api.get<SystemConfig>(`/system_config`).then((res) => {
      const { data } = res;
      if (data.schedule_start_time) {
        set_schedule_start_time(new Date('2000-01-20T' + data.schedule_start_time));
      }
    });
  }, []);
  return (
    <Box>
      <Form onSubmit={handleFormSubmit}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box sx={{ mb: 2, width: '100%' }}>
            <Typography variant="h6" sx={{ p: 1 }}>
              อัปเดตและตรวจสอบข้อมูลบุคคล
            </Typography>
            <Paper sx={{ padding: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TimePicker
                    label="ช่วงเวลาดำเนินการ"
                    value={schedule_start_time}
                    onChange={(value) => {
                      set_schedule_start_time(value ? value : null);
                    }}
                    inputFormat="HH:mm"
                    ampm={false}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        variant="outlined"
                        placeholder="ช่วงเวลาดำเนินการ"
                        autoComplete="off"
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </LocalizationProvider>
        <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
          บันทึก
        </Button>
      </Form>
      <Dialog open={isOpenSuccessDialog} onClose={() => setIsOpenSuccessDialog(false)}>
        <DialogTitle>{'Success'}</DialogTitle>
        <DialogContent>
          <DialogContentText>อัพเดทข้อมูลการตรวจสอบและอัปเดตบุคคลสำเร็จ</DialogContentText>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default SystemSchedule;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
